import axios from "./index";
//redux
import {store} from "../features/store";
import {logoutHandler} from "../features/authentication";

export const dynamicApiCall = async (options) => {
    try {
        const { method, endpoint, data, headers } = options;
        if (localStorage.getItem("at")){
            axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(decodeURIComponent(escape(atob((localStorage.getItem("at"))))))}`
        }
        let config = {
            url: endpoint,
            method: method,
            headers: headers
        }
        method === "GET" ? config.params = data : config.data = data
        return await axios(config);

    } catch (error) {
        console.log(error)
        if (error.response.status === 403 || error.response.status === 401)
            store.dispatch(logoutHandler())
        else
            throw error.response
    }
};
